export default function accessValidation({ institution, role, hasMantenedora = false }) {
  // Usuários da Mantenedora têm acesso livre (podem não ter institution)
  if (role === "MantenedoraAdmin" || role === "MantenedoraManager") {
    return {
      isFreeFlow: true,
      route: "/app/gestao-usuarios"
    };
  }

  // Admin que pertence a uma mantenedora também tem acesso livre
  if (role === "Admin" && hasMantenedora) {
    return {
      isFreeFlow: true,
      route: "/app/instituicoes"
    };
  }

  if (!institution?.id) {
    return {
      isFreeFlow: false,
      route: "/app/configuracoes"
    };
  }

  if (role === "Operator") {
    return {
      isFreeFlow: false,
      route: "/app/importar-dados"
    };
  }

  // ADMIN SCENARIO
  return {
    isFreeFlow: true,
    route: ""
  };
}
